import React, { useState, useCallback, useEffect } from "react";

import swal from "sweetalert";
import { Form, Input, FormField, FormGroup, Button } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 as api, producaov2 } from "../../../../services/apis";

import { Container, Box, Header, FormBlock, TableContainer, NoteText } from "./styles";

import Axios from "axios";

const MatriculasMBA = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState(new Date());
  const [dataFinal, setDataFinal] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [relatorioExcel, setRelatorioExcel] = useState(false);

  const handleGenerateReport = useCallback(async () => {
    setLoading(true);
    setRelatorioExcel(false);

    const errorController = { error: false }

    await producaov2.post(
      "/admin/reports/mba-enrollments",
      {
        data_inicio: dataInicio,
        data_final: dataFinal,
      }
    )
      .then((res) => {
        setRelatorioExcel(res.data.url);

        const acao = JSON.stringify({
          local: "Relatorio",
          texto: `Gerou o relatorio de matricula do MBA entre ${dataInicio} e ${dataFinal}}`,
        });

        api.post("system_logs", { acao });
      })
      .catch((error) => {
        errorController.error = true

        if (!error.response) {
          return;
        };

        if(error?.response?.status === 404) {
          return swal(`Nenhuma matrícula do MBA encontrada com esse período`, `Tente com outro período`, "error");  
        }

        swal(`Algo deu errado na geração do relatório em Excel`, `Se persistir, contate nosso suporte`, "error");
      });

    setLoading(false);

    if (!errorController.error) {
      swal("Confirmado!", "Relatórios gerados com sucesso", "success");
    };

  }, [dataInicio, dataFinal, swal]);

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <Header>Relatório Matrículas MBA</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
              <NoteText>OBS: Os links de acesso aos documentos ficam ativos por 24 horas</NoteText>
            </FormBlock>

            <FormGroup>
              <Button
                color="orange"
                onClick={handleGenerateReport}
                loading={loading}
              >
                Gerar Relatório
              </Button>
              <>
                {relatorioExcel && (
                  <Button
                    style={{ minWidth: "80px" }}
                    onClick={() => window.open(relatorioExcel, "_blank")}
                    color="green"
                  >
                    Baixar Relatório Excel
                  </Button>)
                }
              </>
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default MatriculasMBA;
